import { Controller } from "@hotwired/stimulus"

// Debounced user search + create-private-chat in one click. Server enforces
// permission filters (adherent → membres only) so this controller doesn't
// duplicate that logic.
export default class extends Controller {
  static targets = ["root", "input", "results", "empty"]
  static values  = { searchUrl: String, createUrl: String }

  connect() { this._timer = null }

  close() {
    this.rootTarget.hidden = true
    if (this.hasInputTarget) this.inputTarget.value = ""
    if (this.hasResultsTarget) this.resultsTarget.innerHTML = ""
    if (this.hasEmptyTarget) this.emptyTarget.hidden = true
  }

  search() {
    clearTimeout(this._timer)
    const q = this.inputTarget.value.trim()
    this._timer = setTimeout(() => this._doSearch(q), 250)
  }

  async _doSearch(q) {
    const url = `${this.searchUrlValue}?q=${encodeURIComponent(q)}`
    try {
      const res = await fetch(url, { credentials: "same-origin", headers: { Accept: "application/json" } })
      const items = await res.json()
      this._render(items)
    } catch (e) {
      console.error("[new-chat] search failed", e)
    }
  }

  _render(items) {
    this.resultsTarget.innerHTML = ""
    if (!items || items.length === 0) {
      this.emptyTarget.hidden = false
      return
    }
    this.emptyTarget.hidden = true
    items.forEach((u) => {
      const li = document.createElement("li")
      li.className = "chat-new-modal__result"
      li.innerHTML = `
        <div class="chat-new-modal__avatar">
          ${u.avatar_url ? `<img src="${u.avatar_url}" class="avatar-img">` : `<span class="chat-new-modal__initials">${initialsFor(u.name)}</span>`}
        </div>
        <div class="chat-new-modal__name">
          <span>${escapeHtml(u.name)}</span>
          <span class="chat-new-modal__role chat-new-modal__role--${u.role}">${u.role === "membre" ? "Membre" : "Adhérent"}</span>
        </div>
      `
      li.addEventListener("click", () => this._startChat(u.id))
      this.resultsTarget.appendChild(li)
    })
  }

  async _startChat(participantId) {
    try {
      const res = await fetch(this.createUrlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken(),
          Accept: "application/json",
        },
        body: JSON.stringify({ participant_id: participantId }),
      })
      if (!res.ok) {
        alert("Création impossible. Tu ne peux démarrer une discussion qu'avec un membre de ta junior.")
        return
      }
      const data = await res.json()
      window.location.href = `/intervenant/discussions/${data.id}`
    } catch (e) {
      console.error("[new-chat] create failed", e)
    }
  }
}

function initialsFor(name) {
  return name.split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() || "").join("")
}

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ""
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]))
}
